// Loose junk-prevention — accept anything that looks like a domain or URL:
// at least one dot with characters on both sides, no whitespace, and either
// no scheme or an http(s) scheme. Deliberately does not validate TLDs.
export const WEBSITE_PATTERN = '^(https?://)?[^\\s:\\/]+\\.\\S+$';

export function isValidWebsite(value: string): boolean {
  if (value === '') return true;
  return new RegExp(WEBSITE_PATTERN, 'i').test(value);
}
